module.exports = __webpack_public_path__ + "static/tanarukk-cd258b19b43649858d9dd3764075b9b1.jpeg";